import { FaBarsStaggered } from "react-icons/fa6";
import { useEffect, useState } from "react";
import Breadcrumb from "../Breadcrumbs/Breadcrumb";
import { AiOutlineLogout } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import ConfirmDeleteModal from "../../common/DeleteModel";

const Header = ({ sidebarOpen, setSidebarOpen, sidebarCollapsed }) => {
  const navigate = useNavigate();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const confirmLogout = () => {
    setIsDeleteModalOpen(true);
  };

  const doLogout = () => {
    sessionStorage.clear();
    navigate("/login");
  };

  return (
    <>
    <header className="h-16 bg-white border-b border-gray-200 flex items-center justify-between px-4 sticky top-0 z-[99]">
      <div className="flex w-full items-center justify-between px-4">
        <div className="flex items-center gap-4">
          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="lg:hidden p-2 text-gray-600 hover:bg-gray-50 border border-gray-200"
          >
            <FaBarsStaggered size={18} />
          </button>

          <div className="hidden sm:block">
            <Breadcrumb />
          </div>
        </div>

        <div className="flex items-center gap-3">
          <button
            onClick={confirmLogout}
            className="flex items-center gap-2 px-3 py-2 border border-red-200 text-red-600 hover:bg-red-50 transition-colors font-semibold text-[13px] tracking-wider"
          >
            <AiOutlineLogout size={16} />
            <span className="hidden md:inline">Logout</span>
          </button>
        </div>
      </div>
    </header>

    {/* Modal rendered OUTSIDE header so z-index is not trapped */}
    <ConfirmDeleteModal
      isOpen={isDeleteModalOpen}
      onClose={() => setIsDeleteModalOpen(false)}
      onConfirm={doLogout}
      onConfirmTitle="Confirm, Log Out"
      onTitle="Log Out"
      onContent="Are you sure you want to log out from the system?"
    />
    </>
  );

};

export default Header;
